import { render, staticRenderFns } from "./founderCard.vue?vue&type=template&id=71c8eee2&scoped=true&"
import script from "./founderCard.vue?vue&type=script&lang=js&"
export * from "./founderCard.vue?vue&type=script&lang=js&"
import style0 from "./founderCard.vue?vue&type=style&index=0&id=71c8eee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8eee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c8eee2')) {
      api.createRecord('71c8eee2', component.options)
    } else {
      api.reload('71c8eee2', component.options)
    }
    module.hot.accept("./founderCard.vue?vue&type=template&id=71c8eee2&scoped=true&", function () {
      api.rerender('71c8eee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/startupProfile/founderCard.vue"
export default component.exports